import { z } from "zod";
import { absenceCategories } from "../../../absences";

export const getAbsenceTypesParamSchema = z.object({
	category: z.enum(absenceCategories),
});

export type GetAbsenceTypesParamSchema = z.infer<typeof getAbsenceTypesParamSchema>;
